import {serverDomain} from "../constants";
import KeycloakService from "../KeycloakService";
import {
  BusinessAuditLogResponse,
  CreateBusinessAuditLog,
  ErrorLogResponse,
} from "sharedlibs";

/**
 * Fetches the business audit log from the server
 */
export async function getBusinessAuditLog(
  params: { page: number; pageSize: number; order?: "asc" | "desc"; search?: string },
  opts?: { signal?: AbortSignal },
): Promise<BusinessAuditLogResponse> {
  const token = KeycloakService.instance.getToken()
  let url = `${serverDomain}/auditlog/business?page=${params.page}&pageSize=${params.pageSize}`

  if (params.order) {
    url += "&order=" + params.order
  }
  if (params.search) {
    url += "&search=" + encodeURIComponent(params.search)
  }

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      "Authorization": `Bearer ${token}`
    },
    signal: opts?.signal,
  })

  return await response.json()
}

/**
 * Creates a business audit log entry
 */
export async function createBusinessAuditLog(data: CreateBusinessAuditLog): Promise<void> {
  const token = KeycloakService.instance.getToken()

  await fetch(`${serverDomain}/auditlog/business`, {
    method: 'POST',
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
}

/**
 * Fetches the error log from the server
 */
export async function getErrorLog(
  params: { page: number; pageSize: number; order?: "asc" | "desc"; search?: string },
  opts?: { signal?: AbortSignal },
): Promise<ErrorLogResponse> {
  const token = KeycloakService.instance.getToken()
  let url = `${serverDomain}/auditlog/errors?page=${params.page}&pageSize=${params.pageSize}`

  if (params.order) {
    url += "&order=" + params.order
  }
  if (params.search) {
    url += "&search=" + encodeURIComponent(params.search)
  }

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      "Authorization": `Bearer ${token}`
    },
    signal: opts?.signal,
  })

  return await response.json()
}
